import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import EmailModal from "./EmailModal";

const ContactDetailModal = ({ contactId, onClose }) => {
  const [contact, setContact] = useState(null);
  const [status, setStatus] = useState("");
  const [showEmailModal, setShowEmailModal] = useState(false);

  useEffect(() => {
    api.get(`companyblog/admin/contact-info/${contactId}/`).then((res) => {
      setContact(res.data);
      setStatus(res.data.status);
    });
  }, [contactId]);

  const updateStatus = async () => {
    await api.patch(`companyblog/admin/contact-info/${contactId}/status/`, { status });
    alert("Status updated");
    window.location.reload()
  };

  if (!contact) return null;

  return (
    <>
      <div className="modal-overlay">
        <div className="modal-box">

          {/* HEADER */}
          <div className="modal-header">
            <button className="btn btn-primary">
              Status:
              <select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="new">New</option>
                <option value="closed">Closed</option>
              </select>
            </button>

            <div>
              <button
                className="btn btn-success"
                onClick={() => setShowEmailModal(true)}
              >
                ✉ Email Customer
              </button>

              <button className="btn btn-danger" onClick={onClose}>
                ✕ Close
              </button>
            </div>
          </div>

          {/* BODY */}
          <div className="modal-body">
            <p><strong>Full Name:</strong> {contact.name}</p>
            <p><strong>Phone:</strong> {contact.contact_no}</p>
            <p><strong>Email:</strong> {contact.email || "N/A"}</p>
            <p><strong>Message:</strong> {contact.message || "N/A"}</p>

            <button onClick={updateStatus} className="btn btn-primary mt-2">
              Submit
            </button>
          </div>

        </div>
      </div>

      {/* 📧 EMAIL MODAL */}
      {showEmailModal && (
        <EmailModal
          email={contact.email}
          onClose={() => setShowEmailModal(false)}
        />
      )}
    </>
  );
};

export default ContactDetailModal;
